<template>
  <div :class="$style.wrapper">
    <van-checkbox
      v-model="checked"
      v-if="protocol && privacy"
      icon-size="14px"
      @change="chagneAgree"
    >
      <div :class="$style.agreement">
        阅读并同意
        <button @click="handlerShow(protocol.url)">{{ protocol.name }}</button>
        与
        <button @click="handlerShow(privacy.url)">{{ privacy.name }}</button>
      </div>
    </van-checkbox>
    <TheAgreement :show="show" @handlerShow="handlerShow" :link="link" />
  </div>
</template>

<script>
import { Checkbox } from "vant";
import { mapGetters } from "vuex";
import TheAgreement from "@/components/TheAgreement";

export default {
  name: "Agreement",
  data() {
    return {
      checked: false,
      link: "",
      show: false
    };
  },
  components: {
    TheAgreement,
    [Checkbox.name]: Checkbox
  },
  computed: {
    ...mapGetters(["protocol", "privacy"])
  },
  methods: {
    chagneAgree(val) {
      this.$emit("setFormDisabled", val);
    },
    handlerShow(url) {
      this.link = url;
      this.show = !this.show;
    }
  }
};
</script>

<style lang="less" module>
.wrapper {
  .flex-row;
  justify-content: center;
}

.agreement {
  .flex-center;

  button {
    margin: 0 3px;
    border: 0;
    background-color: transparent;
    color: @green;
  }
}

:global {
  .van-checkbox {
    margin: 25px 5px 0 0px;
  }
}
</style>
